import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {REMIT_BASE_URL} from './config';

export interface OrderMethodAvailabilityItem {
  id: number;
  name: string;
  enabled: boolean;
}

export interface OrderMethodAvailabilityResponse {
  message: string;
  body: {
    paymentMethods: OrderMethodAvailabilityItem[];
    shippingProviders: OrderMethodAvailabilityItem[];
  };
}

export interface SetOrderMethodAvailabilityRequest {
  enabled: boolean;
}

export interface SetOrderMethodAvailabilityResponse {
  message: string;
}

@Injectable()
export class RemitOrderMethodAvailabilityService {
  constructor(
    private http: HttpClient,
    @Inject(REMIT_BASE_URL) private remitApiUrl: string,
  ) {}

  getAvailability(): Observable<OrderMethodAvailabilityResponse> {
    return this.http.get<OrderMethodAvailabilityResponse>(
        this.remitApiUrl + '/staff/order-method-availability',
    );
  }

  setPaymentMethodEnabled(
      methodId: number,
      enabled: boolean,
  ): Observable<SetOrderMethodAvailabilityResponse> {
    return this.http.put<SetOrderMethodAvailabilityResponse>(
        this.remitApiUrl +
          `/staff/order-payment-methods/${methodId}/enabled`,
        {enabled},
    );
  }

  setShippingProviderEnabled(
      providerId: number,
      enabled: boolean,
  ): Observable<SetOrderMethodAvailabilityResponse> {
    return this.http.put<SetOrderMethodAvailabilityResponse>(
        this.remitApiUrl +
          `/staff/order-shipping-providers/${providerId}/enabled`,
        {enabled},
    );
  }
}
